import { render } from "./ChangeLogs.vue?vue&type=template&id=111dbf9d"
import script from "./ChangeLogs.vue?vue&type=script&lang=js"
export * from "./ChangeLogs.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__